/**
 * DropSpotMarkers — Mailbox icons on the Leaflet map for neighborhood drop spots.
 * Tap a mailbox → opens the DropSpotDock (HOARD-style side panel).
 */
import { useEffect, useState } from "react";
import { Marker, useMap } from "react-leaflet";
import L from "leaflet";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const MAILBOX_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
  <rect x="8" y="14" width="24" height="16" rx="3" fill="#1E3A5F" stroke="#7FE3D6" stroke-width="1.5"/>
  <rect x="12" y="10" width="16" height="6" rx="2" fill="#2E5C55"/>
  <path d="M14 22h12" stroke="#7FE3D6" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M14 26h8" stroke="#7FE3D6" stroke-width="1" stroke-linecap="round" opacity="0.6"/>
  <rect x="30" y="12" width="3" height="8" rx="1" fill="#F2CC8F"/>
  <circle cx="20" cy="8" r="3" fill="#F2CC8F" opacity="0.9"/>
  <text x="20" y="10" text-anchor="middle" fill="#1E3A5F" font-size="5" font-weight="900">!</text>
</svg>`;

const mailboxIcon = (count) => L.divIcon({
  className: "",
  html: `<div style="position:relative;cursor:pointer;width:40px;height:40px" data-testid="dropspot-marker">
    ${MAILBOX_SVG}
    ${count > 0 ? `<span style="position:absolute;top:-4px;right:-4px;min-width:16px;height:16px;border-radius:999px;background:#F2CC8F;color:#1E3A5F;font:700 9px/16px Manrope,sans-serif;text-align:center;padding:0 3px">${count}</span>` : ""}
  </div>`,
  iconSize: [40, 40],
  iconAnchor: [20, 36],
});

export const useDropSpots = () => {
  const [spots, setSpots] = useState([]);
  useEffect(() => {
    axios.get(`${API}/dropspots`).then((r) => setSpots(r.data || [])).catch(() => {});
  }, []);
  return spots;
};

export const DropSpotMarkers = ({ spots, onTap }) => {
  return spots.map((s) => (
    <Marker
      key={s.spot_id}
      position={[s.lat, s.lng]}
      icon={mailboxIcon(s.item_count || 0)}
      zIndexOffset={800}
      eventHandlers={{ click: () => onTap(s.spot_id) }}
    />
  ));
};
